import styled from '@emotion/styled';
import Carousel3D from '@ep/components/Carousel3D';
import Container from '@ep/components/Container';
import Media from '@ep/components/Media';
import theme from '@ep/theme';
import { Gcms_Asset } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface GalleryProps {
  mediaGallery: Gcms_Asset[];
}

const ModuleContainer = styled(Container)`
  height: 30rem;
  ${theme.mediaQueries.tablet} {
    height: 30rem;
  }
  ${theme.mediaQueries.mobile} {
    height: 18rem;
  }
`;

const ImageContainer = styled.div`
  height: 20rem;
  width: 30rem;
  ${theme.mediaQueries.mobileAndTablet} {
    height: max-content;
    width: 100%;
  }
`;

const Gallery3DCarouselModule = ({ mediaGallery }: GalleryProps) => {
  return (
    <ModuleContainer>
      <Carousel3D>
        {mediaGallery.map((image: Gcms_Asset) => (
          <ImageContainer id={image.id}>
            <Media key={image.id} media={image} aspectRatio={1.8} fill />
          </ImageContainer>
        ))}
      </Carousel3D>
    </ModuleContainer>
  );
};

export default Gallery3DCarouselModule;
